<ng-container *ngIf="!isInsideModal">

<div class="container-fluid basic_table" >
    <div class="row">
<div class="col-sm-12">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <h5 style="color: grey;"> 
            {{ curentLang === 'en' ? 'Products Info' : (curentLang === 'ar' ? '  معلومات المنتجات ' : ' פרטי מוצרים')}}
        </h5>

       <div>
        <button [hidden]="user_type == 200" class="btn m-1" style=" background-color: #141414; color: #fff;" routerLink="/dashboard/products/new">
            <i class="fa fa-plus-circle mx-1"></i>
          {{ curentLang === 'en' ? 'Add Product' : (curentLang === 'ar' ? '  اضافة منتج' : 'הוספת מוצר')}}
        </button>

        <button [hidden]="user_type == 200" class="btn m-1 btn-outline-success" (click)="downloadTemplate()">
          <i class="fa fa-download mx-1"></i>
          {{ curentLang === 'en' ? 'Download Template' : (curentLang === 'ar' ? 'تنزيل القالب' : 'הורד תבנית') }}
        </button>

        <label [hidden]="user_type == 200" class="btn m-1 btn-outline-primary mb-0" style="cursor:pointer;">
          <i class="fa fa-file-excel-o mx-1"></i>
          {{ curentLang === 'en' ? 'Import Excel' : (curentLang === 'ar' ? 'استيراد Excel' : 'ייבוא Excel') }}
          <input type="file" accept=".xlsx,.xls" style="display:none;" (change)="onExcelFileSelected($event)" />
        </label>

        <button class="btn m-1 mx-1 btn-outline-warning"  (click)="getAllProductsBasedOnMerchant()">
          <i class="fa fa-refresh mx-1"></i> {{ curentLang === 'en' ? 'Refresh' : (curentLang === 'ar' ? '  تحديث   ' : '  רענון    ')}}
      </button>

         </div>
     
      </div>
      <div class="row">
        <div class="col-sm-5">
            <div class="form-group search m-3">
              <label for="seaarch" class="ml-2" style="color: grey;"> {{curentLang === 'en' ? 'Search' : (curentLang === 'ar' ? 'بحث' : 'חיפוש')}}  </label>
                 <input class="form-control  w-100" type="text" name="search"
                  [ngModelOptions]="{standalone: true}" id="seaarch" [(ngModel)]="term"
                  (input)="onSearchInput()"
                  placeholder=" {{curentLang === 'en' ? 'Search name / SKU / barcode' : (curentLang === 'ar' ? 'بحث بالاسم / SKU / الباركود' : 'חיפוש שם / SKU / ברקוד')}}"/>
            </div>
        </div>
    </div>
      <div class="card-block row">
        <div class="col-sm-12 col-lg-12 col-xl-12">
          <!-- Desktop table (lg+) -->
          <div class="table-responsive d-none d-lg-block">
            <table class="table table-light text-center table-hover  " >
              <thead>
                <tr>
                  <th scope="col">{{ curentLang === 'en' ? 'index' : (curentLang === 'ar' ? '  م' : '  מ ') }}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Image' : (curentLang === 'ar' ? 'صورة' : 'תמונה') }}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Product Name ' : (curentLang === 'ar' ? '  أسم المنتج   ' : 'שם מוצר')}} </th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Product Description ' : (curentLang === 'ar' ? '   وصف المنتج  ' : 'תיאור המוצר')}}</th>

                   <th scope="col"> {{ curentLang === 'en' ? 'SKU' : (curentLang === 'ar' ? 'SKU / رقم الصنف' : 'SKU')}}</th>
                   <th scope="col"> {{ curentLang === 'en' ? 'Barcode' : (curentLang === 'ar' ? 'باركود' : 'ברקוד')}}</th>
                   <th scope="col"> {{ curentLang === 'en' ? 'Product Price' : (curentLang === 'ar' ? '   سعر المنتج  ' : 'מחיר')}}</th>
                   <th scope="col"> {{ curentLang === 'en' ? 'Internal Category' : (curentLang === 'ar' ? 'التصنيف الداخلي' : 'קטגוריה פנימית')}}</th>
                   <th scope="col"> {{ curentLang === 'en' ? 'POS' : (curentLang === 'ar' ? 'POS' : 'POS')}}</th>
                   <th scope="col"> {{ curentLang === 'en' ? 'Product Measurement Unit' : (curentLang === 'ar' ? '   وحدة قياس المنتج  ' : 'יחידת מדידה')}}</th>

                  <th scope="col"> {{ curentLang === 'en' ? 'Status  ' : (curentLang === 'ar' ? ' الحالة ' : 'סטטוס ')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Created Date' : (curentLang === 'ar' ? '  تاريخ التسجيل' : 'תאריך הרשמה')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? '   عرض' : '  הצגה   ')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Update  ' : (curentLang === 'ar' ? '   تعديل  ' : '  עריכה ')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Delete  ' : (curentLang === 'ar' ? '   حذف  ' : 'מחיקה')}}</th>

                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of productsData | paginate: {itemsPerPage: limit, currentPage: currentPage, totalItems: total}; let i = index">
                  <td scope="row">{{i+1}}</td>
                  <td>
                    <button
                      *ngIf="item.image_url"
                      type="button"
                      class="product-thumb-btn"
                      (click)="executeFunctionsView(item?.product_id, viewData)"
                      [title]="curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפייה')">
                      <img [src]="item.image_url" alt="" class="product-thumb" />
                    </button>
                    <span *ngIf="!item.image_url" class="text-muted">—</span>
                  </td>
                  <td> 
                    {{curentLang === 'en' ? item.product_name_en?.slice(0, 20) : (curentLang === 'ar' ? item.product_name_ar?.slice(0, 20) : item.product_name_he?.slice(0, 20))}}
                  </td>

                  <td> 
                    {{curentLang === 'en' ? item.des_en?.slice(0, 20) : (curentLang === 'ar' ? item.des_ar?.slice(0, 20) : item.des_he?.slice(0, 20))}}
                  </td>

                   <td>{{item.product_code}}</td>
                   <td>{{item.barcode || '—'}}</td>
                   <td>{{item.price}}</td>
                   <td>{{
                     curentLang === 'en'
                       ? (item.merchantCategory?.name_en || item.categories?.categories_name_en)
                       : (curentLang === 'ar'
                         ? (item.merchantCategory?.name_ar || item.categories?.categories_name_ar)
                         : (item.merchantCategory?.name_he || item.categories?.categories_name_he))
                   }}</td>
                   <td>
                     <span *ngIf="item.show_in_pos !== false && item.show_in_pos !== 0">#{{ item.pos_sort_order ?? 0 }}</span>
                     <span *ngIf="item.show_in_pos === false || item.show_in_pos === 0" class="text-muted">{{ curentLang === 'ar' ? 'مخفي' : (curentLang === 'en' ? 'Hidden' : 'מוסתר') }}</span>
                   </td>
                   <td>{{curentLang === 'en' ? item.measurementUnits?.measurement_unit_name_en : (curentLang === 'ar' ? item.measurementUnits?.measurement_unit_name_ar : item.measurementUnits?.measurement_unit_name_he)}}</td>

                   <td>
                    <button  *ngIf="item.product_status==1" class=" btn" style="border: none;" (click)="changeStatus(item?.product_id, item.product_status)">
                        <i class="fa solid fa-solid fa-toggle-on " style=" color: #213FA6;" ></i>
                    </button> 

                    <button  *ngIf="item.product_status==59" class=" btn"  style="border: none;"(click)="changeStatus(item?.product_id, item.product_status)">
                        <i class="fa solid fa-solid fa-toggle-off " style=" color: red;"></i>
                    </button> 

                  </td>

                   <td>{{ item.createdDate | date: 'dd/MM/yyyy'}}</td>

                  <td>
                    <button class=" btn" style="border: none;" (click)="executeFunctionsView(  item?.product_id,viewData ) ">
                        <i class="fa fa-eye" style="color: grey;   cursor: pointer;"></i>
                    </button>
                  </td> 

                  <td >
                  <a class=" btn" style="border: none;"
                   [routerLink]="['/dashboard/products/edit', item?.product_id]">
                    <i class="fa fa-edit" style=" cursor: pointer; color: green;">
                   </i>
                  </a>
                   </td>

                   <td >
                    <button 
                    [ngStyle]="{ 'pointer-events': item.product_status == 1 ? 'none' : 'auto', 'color': item.product_status == 1 ? 'gray' : 'red' }" 
                    class="btn" 
                    style="border: none;" 
                    (click)="getId(item?.product_id);openVerticallyCentered(dataDeleted)">
                      <i class="fa fa-trash-o" style=" cursor: pointer;"></i>
                      </button>
            
                     </td>

                </tr>
          
              </tbody>
            </table>
          </div>

          <!-- Mobile & tablet cards (< lg) -->
          <div class="crud-cards-list d-lg-none">
            <div class="crud-card" *ngFor="let item of productsData | paginate: {itemsPerPage: limit, currentPage: currentPage, totalItems: total}; let i = index">
              <div class="cc-header">
                <button
                  *ngIf="item.image_url"
                  type="button"
                  class="cc-avatar-btn"
                  (click)="executeFunctionsView(item?.product_id, viewData)"
                  [title]="curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפייה')">
                  <img [src]="item.image_url" alt="" class="cc-avatar-img" />
                </button>
                <div class="cc-avatar" *ngIf="!item.image_url">
                  <span>{{ (curentLang === 'en' ? item.product_name_en : (curentLang === 'ar' ? item.product_name_ar : item.product_name_he))?.charAt(0)?.toUpperCase() || '?' }}</span>
                </div>
                <div class="cc-title-block">
                  <div class="cc-name">{{ curentLang === 'en' ? item.product_name_en : (curentLang === 'ar' ? item.product_name_ar : item.product_name_he) }}</div>
                  <div class="cc-sub">{{ item.product_code }} · {{ item.barcode || '—' }} · {{ item.price }}</div>
                </div>
                <span class="cc-badge" [style.background]="item.product_status == 1 ? '#e8f5e9' : '#f5f5f5'" [style.color]="item.product_status == 1 ? '#2e7d32' : '#757575'">
                  {{ item.product_status == 1 ? (curentLang === 'ar' ? 'نشط' : (curentLang === 'he' ? 'פעיל' : 'Active')) : (curentLang === 'ar' ? 'غير نشط' : (curentLang === 'he' ? 'לא פעיל' : 'Inactive')) }}
                </span>
              </div>
              <div class="cc-body">
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Category' : (curentLang === 'ar' ? 'التصنيف' : 'קטגוריה') }}</span>
                  <span class="cc-value">{{
                    curentLang === 'en'
                      ? (item.merchantCategory?.name_en || item.categories?.categories_name_en)
                      : (curentLang === 'ar'
                        ? (item.merchantCategory?.name_ar || item.categories?.categories_name_ar)
                        : (item.merchantCategory?.name_he || item.categories?.categories_name_he))
                  }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Unit' : (curentLang === 'ar' ? 'وحدة قياس' : 'יחידת מדידה') }}</span>
                  <span class="cc-value">{{ curentLang === 'en' ? item.measurementUnits?.measurement_unit_name_en : (curentLang === 'ar' ? item.measurementUnits?.measurement_unit_name_ar : item.measurementUnits?.measurement_unit_name_he) }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">POS</span>
                  <span class="cc-value">
                    <ng-container *ngIf="item.show_in_pos !== false && item.show_in_pos !== 0">#{{ item.pos_sort_order ?? 0 }}</ng-container>
                    <ng-container *ngIf="item.show_in_pos === false || item.show_in_pos === 0">{{ curentLang === 'ar' ? 'مخفي' : (curentLang === 'en' ? 'Hidden' : 'מוסתר') }}</ng-container>
                  </span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Created' : (curentLang === 'ar' ? 'تاريخ التسجيل' : 'תאריך הרשמה') }}</span>
                  <span class="cc-value">{{ item.createdDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="cc-info-row">
                  <span class="cc-label">{{ curentLang === 'en' ? 'Status' : (curentLang === 'ar' ? 'الحالة' : 'סטטוס') }}</span>
                  <button *ngIf="item.product_status==1" class="btn p-0 border-0" (click)="changeStatus(item?.product_id, item.product_status)">
                    <i class="fa fa-toggle-on" style="color: #213FA6; font-size: 20px;"></i>
                  </button>
                  <button *ngIf="item.product_status==59" class="btn p-0 border-0" (click)="changeStatus(item?.product_id, item.product_status)">
                    <i class="fa fa-toggle-off" style="color: red; font-size: 20px;"></i>
                  </button>
                </div>
              </div>
              <div class="cc-actions">
                <button class="cc-action-btn cc-action-view" (click)="executeFunctionsView(item?.product_id, viewData)" title="{{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפייה') }}">
                  <i class="fa fa-eye"></i>
                </button>
                <a class="cc-action-btn cc-action-edit" [routerLink]="['/dashboard/products/edit', item?.product_id]" title="{{ curentLang === 'en' ? 'Update' : (curentLang === 'ar' ? 'تعديل' : 'עריכה') }}">
                  <i class="fa fa-edit"></i>
                </a>
                <button [attr.disabled]="item.product_status == 1 ? true : null" class="cc-action-btn cc-action-delete" (click)="getId(item?.product_id);openVerticallyCentered(dataDeleted)" title="{{ curentLang === 'en' ? 'Delete' : (curentLang === 'ar' ? 'حذف' : 'מחיקה') }}">
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="pagination-container">
            <pagination-controls 
              (pageChange)="onPageChange($event)" 
              (totalItems)="total" 
              (currentPage)="currentPage">
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>

    </div>
</div>

</ng-container>
<!--add product-->

<ng-template #content let-modal>
  <div class="modal-header d-flex justify-content-between">
      <h6 class="modal-title" style="color: grey;">
          {{ curentLang === 'en' ? 'Add Product ' : (curentLang === 'ar' ? ' اضافة منتج ' : 'הוספת מוצר')}} 
      </h6>

      <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">

    </button>
  </div>
  <div class="modal-body">
      <div class="container-fluid">
          <div class="edit-profile">
              <div class="row d-flex justify-content-between">
                  <form [formGroup]="addProduct" novalidate [ngClass]="{ 'was-validated': validate }">
                      <div class="row">
                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Product Name ' : (curentLang === 'ar' ? '  اسم المنتج    ' : ' שם מוצר ')}}
                                  <span class="text-danger">*</span>
                              </label>
                              <input required style="color: grey;" class="form-control" onlyAlphabets
                                  type="text" formControlName="product_name_he" maxlength="80" />
                              <div *ngIf="addProduct.get('product_name_he')?.invalid && addProduct.get('product_name_he')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please enter product name' : (curentLang === 'ar' ? '   الرجاء ادخال أسم المنتج ' : ' נא להזין את שם המוצר ')}} </p> 
                              </div>
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'SKU / Product Code' : (curentLang === 'ar' ? 'SKU / رقم الصنف' : 'SKU / קוד מוצר')}}
                              </label>
                              <input style="color: grey;" onlyAlphabets
                                  class="form-control" type="text" formControlName="product_code" maxlength="20"
                                  [attr.disabled]="addProduct.value.auto_generate_sku ? true : null" />
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Barcode' : (curentLang === 'ar' ? 'باركود' : 'ברקוד')}}
                              </label>
                              <input style="color: grey;" class="form-control" type="text" formControlName="barcode" maxlength="64"
                                  [attr.disabled]="addProduct.value.auto_generate_barcode ? true : null" />
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Product Price' : (curentLang === 'ar' ? '    سعر المنتج ' : '   מחיר')}}
                                  <span class="text-danger">*</span>
                              </label>
                              <input style="color: grey;" onlyAlphabets required
                                  class="form-control" type="number" formControlName="price" maxlength="20" />
                              <div *ngIf="addProduct.get('price')?.invalid && addProduct.get('price')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please enter product price' : (curentLang === 'ar' ? '   الرجاء ادخال سعر المنتج ' : ' נא להזין את מחיר המוצר ')}} </p> 
                              </div>
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;">
                                  {{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}
                              </label>
                              <ng-select formControlName="company_id" [clearable]="true"
                                  placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                  <ng-option *ngFor="let item of companiesData" [value]="item?.company_id">
                                      {{ (item | companyName:curentLang) }}
                                  </ng-option>
                              </ng-select>
                              <small class="text-muted">
                                {{ curentLang === 'en' ? 'Required when SKU/Barcode is set or auto-generated' : (curentLang === 'ar' ? 'مطلوب عند تعيين أو توليد SKU / Barcode' : 'נדרש בעת הגדרה או יצירה של SKU / Barcode') }}
                              </small>
                          </div>

                          <div class="mb-3 col-xl-2 col-md-4">
                              <label class="form-label" style="color: grey;">
                                  {{ curentLang === 'en' ? 'POS Order' : (curentLang === 'ar' ? 'ترتيب POS' : 'סדר POS') }}
                              </label>
                              <input class="form-control" type="number" formControlName="pos_sort_order" />
                          </div>

                          <div class="mb-3 col-xl-2 col-md-4 d-flex flex-column justify-content-end">
                              <div class="form-check mb-2">
                                  <input class="form-check-input" type="checkbox" id="add_show_in_pos" formControlName="show_in_pos" />
                                  <label class="form-check-label" for="add_show_in_pos" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Show in POS' : (curentLang === 'ar' ? 'إظهار في POS' : 'הצג ב-POS') }}
                                  </label>
                              </div>
                              <div class="form-check mb-1">
                                  <input class="form-check-input" type="checkbox" id="add_auto_sku" formControlName="auto_generate_sku" />
                                  <label class="form-check-label" for="add_auto_sku" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Auto SKU' : (curentLang === 'ar' ? 'توليد SKU' : 'יצירת SKU') }}
                                  </label>
                              </div>
                              <div class="form-check">
                                  <input class="form-check-input" type="checkbox" id="add_auto_barcode" formControlName="auto_generate_barcode" />
                                  <label class="form-check-label" for="add_auto_barcode" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Auto Barcode' : (curentLang === 'ar' ? 'توليد باركود' : 'יצירת ברקוד') }}
                                  </label>
                              </div>
                          </div>

                          <div class="mb-3 col-xl-6 col-md-6">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Internal Category' : (curentLang === 'ar' ? 'التصنيف الداخلي' : 'קטגוריה פנימית')}}
                              </label>
                              <ng-select formControlName="merchant_category_id" [clearable]="true"
                                  placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                  <ng-option *ngFor="let item of merchantCategoriesData"
                                      [value]="merchantCategoryPk(item)">
                                      {{ merchantCategoryLabel(item) }}
                                  </ng-option>
                              </ng-select>
                          </div>

                          <div class="mb-3 col-xl-6 col-md-6">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'General Category (legacy)' : (curentLang === 'ar' ? 'التصنيف العام (قديم)' : 'קטגוריה כללית')}}
                              </label>
                              <ng-select formControlName="categories_id" [clearable]="true"
                                  (change)="filter($event)" style="cursor: pointer;"
                                  placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                  <ng-option *ngFor="let item of categoriesData; let i = index"
                                      [value]="item?.categories_id">
                                      {{ curentLang === 'en' ?  item?.categories_name_en :(curentLang === 'ar' ? item?.categories_name_ar  :  item?.categories_name_he )}}
                                  </ng-option>
                              </ng-select>
                          </div>

                          <div class="mb-3 col-xl-6 col-md-6">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Measurement Unit Product' : (curentLang === 'ar' ? '  وحدة قياس المنتج ' : 'יחידת מדידה')}}
                                  <span class="text-danger">*</span>
                              </label>
                              <ng-select formControlName="measurement_unit_id" [(ngModel)]="selectedMeasurementUnit" required
                                  (change)="filterMeasurementUnit(selectedMeasurementUnit)" style="cursor: pointer;"
                                  placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                  <ng-option *ngFor="let item of unitMesauereData; let i = index"
                                      [value]="item?.measurement_unit_id">
                                      {{ curentLang === 'en' ?  item?.measurement_unit_name_en :(curentLang === 'ar' ? item?.measurement_unit_name_ar  :  item?.measurement_unit_name_he )}}
                                  </ng-option>
                              </ng-select>
                              <div *ngIf="addProduct.get('measurement_unit_id')?.invalid && addProduct.get('measurement_unit_id')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please chooce measurement unit name' : (curentLang === 'ar' ? '   الرجاء اختيار وحدة قياس المنتج  ' : '  אנא בחר יחידת מדידה של מוצר  ')}} </p>  
                              </div>
                          </div>

                          <div class="mb-3 col-xl-12">
                              <label class="form-label" style="color: grey;">
                                {{ curentLang === 'en' ? 'Product Image (AI)' : (curentLang === 'ar' ? 'صورة المنتج (AI)' : 'תמונת מוצר (AI)') }}
                              </label>
                              <div class="d-flex flex-wrap align-items-center gap-3">
                                <img *ngIf="currentImageUrl && !productId" [src]="currentImageUrl" alt="" class="product-image-preview" />
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" id="add_generate_ai" formControlName="generate_ai_image" />
                                  <label class="form-check-label" for="add_generate_ai" style="color:grey;">
                                    {{ curentLang === 'en' ? 'Generate AI image on save' : (curentLang === 'ar' ? 'توليد صورة AI عند الحفظ' : 'צור תמונת AI בשמירה') }}
                                  </label>
                                </div>
                                <input class="form-control form-control-sm" style="max-width:280px;" type="text"
                                  formControlName="ai_image_prompt"
                                  placeholder="{{ curentLang === 'en' ? 'AI prompt (optional)' : (curentLang === 'ar' ? 'وصف AI (اختياري)' : 'תיאור AI (אופציונלי)') }}" />
                                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="generateAiImage(true)">
                                  <i class="fa fa-magic mx-1"></i>
                                  {{ curentLang === 'en' ? 'Preview AI' : (curentLang === 'ar' ? 'معاينة AI' : 'תצוגת AI') }}
                                </button>
                                <small *ngIf="pendingPreviewKey" class="text-success">
                                  {{ curentLang === 'en' ? 'Preview ready — will apply on save' : (curentLang === 'ar' ? 'المعاينة جاهزة — تُعتمد عند الحفظ' : 'התצוגה מוכנה — תוחל בשמירה') }}
                                </small>
                              </div>
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Description En' : (curentLang === 'ar' ? '  وصف المنتج انجليزي  ' : '   תיאור המוצר באנגלית')}} 
                                  <span class="text-danger">*</span>
                              </label>
                              <textarea maxlength="600" name="" onlyAlphabets required
                                  id="des_en" cols="10" rows="5" type="text"
                                  class="form-control form-control-sm"
                                  formControlName="des_en">
                              </textarea>
                              <div *ngIf="addProduct.get('des_en')?.invalid && addProduct.get('des_en')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}} </p> 
                              </div>
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Description Ar' : (curentLang === 'ar' ? '  وصف المنتج عربي  ' : '   תיאור המוצר בערבית    ')}}   
                                  <span class="text-danger">*</span>
                              </label>
                              <textarea maxlength="600" name="" onlyAlphabets required
                                  id="des_ar" cols="10" rows="5" type="text"
                                  class="form-control form-control-sm"
                                  formControlName="des_ar">
                              </textarea>
                              <div *ngIf="addProduct.get('des_ar')?.invalid && addProduct.get('des_ar')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}} </p> 
                              </div>
                          </div>

                          <div class="mb-3 col-xl-4 col-md-4">
                              <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Description' : (curentLang === 'ar' ? '  وصف المنتج   ' : '   תיאור מוצר בעברית    ')}} 
                                  <span class="text-danger">*</span>
                              </label>
                              <textarea maxlength="600" name="" onlyAlphabets required
                                  id="des_he" cols="10" rows="5" type="text"
                                  class="form-control form-control-sm"
                                  formControlName="des_he">
                              </textarea>
                              <div *ngIf="addProduct.get('des_he')?.invalid && addProduct.get('des_he')?.touched" class="text-danger">
                                  <p>{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}} </p> 
                              </div>
                          </div>
                      </div>

                      <div class="modal-footer">
                          <button type="button" class="btn btn-sm m-auto mt-2" 
                              style="background-color: #141414; color: #fff;"
                              (click)="addedData()"> 
                              {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
                              <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
                          </button>

                          <button type="button" class="btn btn-sm m-auto mt-2 btn-danger"
                              (click)="modal.close('Close click')">
                              {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
                              <i class="fa fa-rotate-left mx-1"></i>
                          </button>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</ng-template>


<!--update product-->

<ng-template #updatedData let-modal>
    <div class="modal-header d-flex justify-content-between">
        <h6 class="modal-title"style="color: grey;">
                {{ curentLang === 'en' ? 'Update Info ' : (curentLang === 'ar' ? ' تعديل المعلومات ' : '    עריכה   ')}} 
        </h6>
        <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
             
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid ">
            <div class="edit-profile">
              <div class="row d-flex justify-content-between">
                      <form  [formGroup]="updateProduct"  novalidate [ngClass]="{ 'was-validated': validateUpdate }">
                        <div class="row">
                             <div class="mb-3 col-xl-4 col-md-4 ">
                                <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Product Name Ar' : (curentLang === 'ar' ? '  اسم المنتج عربي   ' : '  שם המוצר בערבית  ')}}
                                  <span class="text-danger">*</span>
                               </label>
                                <input style="color: grey;"  onlyAlphabets required=""
                                 class="form-control" maxlength="80" 
                                 type="text" formControlName="product_name_ar" 
                                  />
                                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product name' : (curentLang === 'ar' ? '   الرجاء ادخال أسم المنتج ' : ' נא להזין את שם המוצר      ')}}  </div>

                              </div> 
              
                               <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Product Name En' : (curentLang === 'ar' ? '  اسم المنتج انجليزي   ' : '   שם המוצר באנגלית  ')}}
                                 </label>
                                  <input style="color: grey;"   onlyAlphabets required=""
                                  class="form-control"
                                   type="text"
                                   maxlength="80"
                                    formControlName="product_name_en"
                                   />
                                   <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product name' : (curentLang === 'ar' ? '   الرجاء ادخال أسم المنتج ' : ' נא להזין את שם המוצר      ')}}  </div>

                                </div> 
              
                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Product Name He' : (curentLang === 'ar' ? '  اسم المنتج عبري   ' : '  שם בעברית  ')}}
                                    <span class="text-danger">*</span>
                                 </label>
                                  <input style="color: grey;" class="form-control"  onlyAlphabets required=""
                                   type="text" 
                                   formControlName="product_name_he" 
                                   maxlength="80"
                                  />
                                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product name' : (curentLang === 'ar' ? '   الرجاء ادخال أسم المنتج ' : ' נא להזין את שם המוצר      ')}}  </div>

                                </div>
              
                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'SKU / Product Code' : (curentLang === 'ar' ? 'SKU / رقم الصنف' : 'SKU / קוד מוצר')}}
                                 </label>
                                  <input style="color: grey;" onlyAlphabets
                                  class="form-control" type="text" 
                                   formControlName="product_code"
                                   maxlength="20"
                                   [attr.disabled]="updateProduct.value.auto_generate_sku ? true : null"
                                     />
                                </div>

                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Barcode' : (curentLang === 'ar' ? 'باركود' : 'ברקוד')}}
                                 </label>
                                  <input style="color: grey;" class="form-control" type="text" 
                                   formControlName="barcode" maxlength="64"
                                   [attr.disabled]="updateProduct.value.auto_generate_barcode ? true : null" />
                                </div>

                                <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                      {{ curentLang === 'en' ? 'Product Price' : (curentLang === 'ar' ? ' سعر المنتج ' : 'מחיר')}}
                                      <span class="text-danger">*</span>
                                   </label>
                                    <input style="color: grey;"   onlyAlphabets required=""
                                    class="form-control" type="text" 
                                     formControlName="price"
                                     maxlength="20"
                                       />
                                       <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product price' : (curentLang === 'ar' ? '   الرجاء ادخال سعر المنتج ' : ' נא להזין את מחיר המוצר ')}}  </div>

                                  </div>

                                  <div class="mb-3 col-xl-4 col-md-4">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}
                                    </label>
                                    <ng-select formControlName="company_id" [clearable]="true"
                                      placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                      <ng-option *ngFor="let item of companiesData" [value]="item?.company_id">
                                        {{ (item | companyName:curentLang) }}
                                      </ng-option>
                                    </ng-select>
                                  </div>

                                  <div class="mb-3 col-xl-2 col-md-4">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'POS Order' : (curentLang === 'ar' ? 'ترتيب POS' : 'סדר POS') }}
                                    </label>
                                    <input class="form-control" type="number" formControlName="pos_sort_order" />
                                  </div>

                                  <div class="mb-3 col-xl-6 col-md-12 d-flex flex-wrap align-items-end gap-3">
                                    <div class="form-check">
                                      <input class="form-check-input" type="checkbox" id="upd_show_in_pos" formControlName="show_in_pos" />
                                      <label class="form-check-label" for="upd_show_in_pos" style="color: grey;">
                                        {{ curentLang === 'en' ? 'Show in POS' : (curentLang === 'ar' ? 'إظهار في POS' : 'הצג ב-POS') }}
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input class="form-check-input" type="checkbox" id="upd_auto_sku" formControlName="auto_generate_sku" />
                                      <label class="form-check-label" for="upd_auto_sku" style="color: grey;">
                                        {{ curentLang === 'en' ? 'Auto SKU' : (curentLang === 'ar' ? 'توليد SKU' : 'יצירת SKU') }}
                                      </label>
                                    </div>
                                    <div class="form-check">
                                      <input class="form-check-input" type="checkbox" id="upd_auto_barcode" formControlName="auto_generate_barcode" />
                                      <label class="form-check-label" for="upd_auto_barcode" style="color: grey;">
                                        {{ curentLang === 'en' ? 'Auto Barcode' : (curentLang === 'ar' ? 'توليد باركود' : 'יצירת ברקוד') }}
                                      </label>
                                    </div>
                                  </div>

                                  <div class="mb-3 col-xl-12 col-md-12">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Product Image' : (curentLang === 'ar' ? 'صورة المنتج' : 'תמונת מוצר') }}
                                    </label>
                                    <div class="d-flex flex-wrap align-items-center gap-3">
                                      <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="product-image-preview" />
                                      <label class="btn btn-sm btn-outline-primary mb-0" style="cursor:pointer;">
                                        <i class="fa fa-upload mx-1"></i>
                                        {{ curentLang === 'en' ? 'Upload' : (curentLang === 'ar' ? 'رفع' : 'העלה') }}
                                        <input type="file" accept="image/*" style="display:none;" (change)="onProductImageSelected($event)" />
                                      </label>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="upd_generate_ai" formControlName="generate_ai_image" />
                                        <label class="form-check-label" for="upd_generate_ai" style="color:grey;">
                                          {{ curentLang === 'en' ? 'Generate AI on save' : (curentLang === 'ar' ? 'توليد AI عند الحفظ' : 'צור AI בשמירה') }}
                                        </label>
                                      </div>
                                      <div class="d-flex align-items-center gap-2 flex-grow-1" style="min-width:220px;">
                                        <input class="form-control form-control-sm" type="text" formControlName="ai_image_prompt"
                                          placeholder="{{ curentLang === 'en' ? 'AI prompt (optional)' : (curentLang === 'ar' ? 'وصف للذكاء الاصطناعي (اختياري)' : 'תיאור ל-AI (אופציונלי)') }}" />
                                        <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap" (click)="generateAiImage(false)">
                                          <i class="fa fa-magic mx-1"></i>
                                          {{ curentLang === 'en' ? 'Preview AI' : (curentLang === 'ar' ? 'معاينة AI' : 'תצוגת AI') }}
                                        </button>
                                      </div>
                                      <small *ngIf="pendingPreviewKey" class="text-success">
                                        {{ curentLang === 'en' ? 'Preview ready — will apply on save' : (curentLang === 'ar' ? 'المعاينة جاهزة — تُعتمد عند الحفظ' : 'התצוגה מוכנה — תוחל בשמירה') }}
                                      </small>
                                    </div>
                                  </div>

                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Internal Category' : (curentLang === 'ar' ? 'التصنيف الداخلي' : 'קטגוריה פנימית')}}
                                     </label>
                                   <ng-select formControlName="merchant_category_id" [clearable]="true"
                                   style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                   <ng-option *ngFor="let item of merchantCategoriesData" [value]="merchantCategoryPk(item)">
                                    {{ merchantCategoryLabel(item) }}
                                  </ng-option>
                                  </ng-select>
                                  </div>

                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'General Category (legacy)' : (curentLang === 'ar' ? 'التصنيف العام (قديم)' : 'קטגוריה כללית')}}
                                     </label>
                                   <ng-select formControlName="categories_id" (change)="filter($event)" [clearable]="true"
                                   style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                   <ng-option *ngFor="let item of categoriesData; let i = index " [value]="item?.categories_id">
                                    {{ curentLang === 'en' ?  item?.categories_name_en :(curentLang === 'ar' ? item?.categories_name_ar  :  item?.categories_name_he )}}
                                  </ng-option>
                                  </ng-select>
                                  </div>
                                         
                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Measurement Unit Product' : (curentLang === 'ar' ? '  وحدة قياس المنتج ' : ' יחידת מדידה')}}
                                        <span class="text-danger">*</span>
                                     </label>
                                  

                                   <ng-select formControlName="measurement_unit_id" (change)="filterMeasurementUnit($event)" onlyAlphabets required=""
                                   style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                    <ng-option *ngFor="let item of unitMesauereData; let i = index " [value]="item?.measurement_unit_id">
                                      {{ curentLang === 'en' ?  item?.measurement_unit_name_en :(curentLang === 'ar' ? item?.measurement_unit_name_ar  :  item?.measurement_unit_name_he )}}
                                    </ng-option>
                                  </ng-select>
                                  <div *ngIf="updateProduct.get('measurement_unit_id')?.errors?.required" class="text-danger">
                                    <p>{{ curentLang === 'en' ? 'please chooce measurement unit name' : (curentLang === 'ar' ? '   الرجاء اختيار وحدة قياس المنتج  ' : '  אנא בחר יחידת מדידה של מוצר  ')}} </p>  
                                    </div>
                                  </div>

                                  <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description En' : (curentLang === 'ar' ? '  وصف المنتج انجليزي  ' : '   תיאור המוצר באנגלית')}} 
                                        <span class="text-danger">*</span>
                                   </label>
                                        <textarea
                                         maxlength="600" name="" onlyAlphabets required=""
                                          id="des_en" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_en">
                                   </textarea>
                                   <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}}  </div>

                                  </div> 

                                   <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description Ar' : (curentLang === 'ar' ? '  وصف المنتج عربي  ' : '   תיאור המוצר בערבית    ')}}   
                                        <span class="text-danger">*</span>
                                   </label>
                                        <textarea
                                         maxlength="600" name="" onlyAlphabets required=""
                                          id="des_ar" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_ar">
                                   </textarea>
                                   <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}}  </div>

                                  </div> 
              
                                  <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description' : (curentLang === 'ar' ? '  وصف المنتج   ' : '   תיאור מוצר בעברית    ')}} 
                                        <span class="text-danger">*</span>
                                   </label>
                                        <textarea
                                         maxlength="600" name="" onlyAlphabets required=""
                                          id="des_he" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_he">
                                   </textarea>
                                   <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'please enter product description  ' : (curentLang === 'ar' ? '   الرجاء ادخال وصف المنتج ' : 'נא להזין תיאור מוצר')}}  </div>

                                  </div>
                        </div>
                  
                    
        
                          <div class="modal-footer">

                            <button type="button"  
                             class="btn btn-sm m-auto mt-2" 
                            style="background-color: #141414; color: #fff;"
                             (click)="updateProductsById()"
                             > 
                              {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
                              <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
                          </button>
                      
                              <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
                                  {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
                                  <i class="fa fa-rotate-left mx-1"></i>
                              </button>
                      
                            
                      
                          </div>
                      </form>
              
            </div>
            
          </div>
        
        </div>
    </div>
   
</ng-template>

<!--view product-->

<ng-template #viewData let-modal>
    <div class="modal-header d-flex justify-content-between">
        <h6 class="modal-title"style="color: grey;">
                {{ curentLang === 'en' ? 'View Info ' : (curentLang === 'ar' ? ' مشاهدة المعلومات ' : 'צפיה   ')}} 
        </h6>
        <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
             
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid ">
            <div class="edit-profile">
              <div class="row d-flex justify-content-between">
                      <form  [formGroup]="updateProduct">
                        <div class="row">
                             <div class="mb-3 col-xl-4 col-md-4 ">
                                <label class="form-label" style="color: grey;"> 
                                  {{ curentLang === 'en' ? 'Product Name Ar' : (curentLang === 'ar' ? '  اسم المنتج عربي   ' : '  שם המוצר בערבית  ')}}
                               </label>
                                <input style="color: grey;" readonly
                                 class="form-control" maxlength="80" 
                                 type="text" formControlName="product_name_ar" 
                                  />
                              </div> 
              
                             <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Product Name En' : (curentLang === 'ar' ? '  اسم المنتج انجليزي   ' : '   שם המוצר באנגלית  ')}}
                                 </label>
                                  <input style="color: grey;" readonly
                                  class="form-control"
                                   type="text"
                                   maxlength="80"
                                    formControlName="product_name_en"
                                   />
                                </div> 
              
                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Product Name He' : (curentLang === 'ar' ? '  اسم المنتج عبري   ' : 'שם בעברית')}}
                                 </label>
                                  <input style="color: grey;" class="form-control"readonly
                                   type="text" 
                                   formControlName="product_name_he" 
                                   maxlength="80"
                                  />
                                   
                                </div>
              
                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'SKU / Product Code' : (curentLang === 'ar' ? 'SKU / رقم الصنف' : 'SKU / קוד מוצר')}}
                                 </label>
                                  <input style="color: grey;" readonly
                                  class="form-control" type="text" 
                                   formControlName="product_code"
                                   maxlength="20"
                                     />
                                </div>

                                <div class="mb-3 col-xl-4 col-md-4 ">
                                  <label class="form-label" style="color: grey;"> 
                                    {{ curentLang === 'en' ? 'Barcode' : (curentLang === 'ar' ? 'باركود' : 'ברקוד')}}
                                 </label>
                                  <input style="color: grey;" readonly class="form-control" type="text" formControlName="barcode" />
                                </div>

                                <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                      {{ curentLang === 'en' ? 'Product Price' : (curentLang === 'ar' ? ' سعر المنتج ' : 'מחיר')}}
                                   </label>
                                    <input style="color: grey;" readonly
                                    class="form-control" type="text" 
                                     formControlName="price"
                                     maxlength="20"
                                       />
                                  </div>

                                  <div class="mb-3 col-xl-4 col-md-4">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Company' : (curentLang === 'ar' ? 'المصلحة التجارية' : 'חברה') }}
                                    </label>
                                    <ng-select formControlName="company_id" [clearable]="false"
                                      placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                      <ng-option *ngFor="let item of companiesData" [value]="item?.company_id">
                                        {{ (item | companyName:curentLang) }}
                                      </ng-option>
                                    </ng-select>
                                  </div>

                                  <div class="mb-3 col-xl-4 col-md-4">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'POS Order' : (curentLang === 'ar' ? 'ترتيب POS' : 'סדר POS') }}
                                    </label>
                                    <input class="form-control" type="number" formControlName="pos_sort_order" readonly />
                                  </div>

                                  <div class="mb-3 col-xl-4 col-md-4 d-flex align-items-end">
                                    <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="show_in_pos" disabled />
                                      <label class="form-check-label" style="color: grey;">
                                        {{ curentLang === 'en' ? 'Show in POS' : (curentLang === 'ar' ? 'إظهار في POS' : 'הצג ב-POS') }}
                                      </label>
                                    </div>
                                  </div>

                                  <div class="mb-3 col-xl-12" *ngIf="currentImageUrl">
                                    <label class="form-label" style="color: grey;">
                                      {{ curentLang === 'en' ? 'Product Image' : (curentLang === 'ar' ? 'صورة المنتج' : 'תמונת מוצר') }}
                                    </label>
                                    <div>
                                      <img [src]="currentImageUrl" alt="" class="product-image-preview" />
                                    </div>
                                  </div>

                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Internal Category' : (curentLang === 'ar' ? 'التصنيف الداخلي' : 'קטגוריה פנימית')}}
                                     </label>
                                     <ng-select formControlName="merchant_category_id" [clearable]="false"
                                      placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                      <ng-option *ngFor="let item of merchantCategoriesData" [value]="merchantCategoryPk(item)">
                                        {{ merchantCategoryLabel(item) }}
                                      </ng-option>
                                    </ng-select>
                                  </div>

                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'General Category (legacy)' : (curentLang === 'ar' ? 'التصنيف العام (قديم)' : 'קטגוריה כללית')}}
                                     </label>
                                     <ng-select formControlName="categories_id"   (change)="filter($event)" style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                      <ng-option *ngFor="let item of categoriesData; let i = index " [value]="item?.categories_id">
                                        {{ curentLang === 'en' ?  item?.categories_name_en :(curentLang === 'ar' ? item?.categories_name_ar  :  item?.categories_name_he )}}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                         
                                  <div class="mb-3 col-xl-6 col-md-6 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Measurement Unit Product' : (curentLang === 'ar' ? '  وحدة قياس المنتج ' : 'יחידת מדידה')}}
                                     </label>  
                                     
                                     <ng-select formControlName="measurement_unit_id"    (change)="filterMeasurementUnit($event)" style="cursor: pointer;" placeholder="{{ curentLang === 'en' ? 'Select' : (curentLang === 'ar' ? 'اختر' : 'בחר') }}">
                                      <ng-option *ngFor="let item of unitMesauereData; let i = index " [value]="item?.measurement_unit_id">
                                        {{ curentLang === 'en' ?  item?.measurement_unit_name_en :(curentLang === 'ar' ? item?.measurement_unit_name_ar  :  item?.measurement_unit_name_he )}}
                                      </ng-option>
                                    </ng-select>
                                    
                                  </div>

                                   <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description En' : (curentLang === 'ar' ? '  وصف المنتج انجليزي  ' : '   תיאור המוצר באנגלית')}} 
                                   </label>
                                        <textarea
                                         maxlength="600" name=""readonly
                                          id="des_en" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_en">


                                   </textarea>
                                  </div> 

                                   <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description Ar' : (curentLang === 'ar' ? '  وصف المنتج عربي  ' : '   תיאור המוצר בערבית    ')}}   
                                   </label>
                                        <textarea
                                         maxlength="600" name=""readonly
                                          id="des_ar" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_ar">
                                   </textarea>
                                  </div> 
              
                                  <div class="mb-3 col-xl-4 col-md-4 ">
                                    <label class="form-label" style="color: grey;"> 
                                        {{ curentLang === 'en' ? 'Description  ' : (curentLang === 'ar' ? '  وصف المنتج    ' : 'תיאור מוצר')}} 
                                   </label>
                                        <textarea
                                         maxlength="600" name=""readonly
                                          id="des_he" cols="10" rows="5" type="text"
                                          class="form-control form-control-sm"
                                           formControlName="des_he">
                                   </textarea>
                                  </div>
                        </div>
                  
            
                      </form>
              
            </div>
            
          </div>
        
        </div>
    </div>
   
</ng-template>


    <!--Delete product-->

    <ng-template #dataDeleted let-modal>
        <div class="modal-header">
            <h4 class="modal-title"></h4>
            <button type="button" class="close btn-close"  style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
                 
            </button>
        </div>
        <div class="modal-body">
            <p class="text-center text-danger"> <i class="fa fa-trash text-danger"></i>
              {{curentLang === 'en' ? 'Are you sure you want to delete it?' : (curentLang === 'ar' ? '  هل تريد بالتأكيد حذفه؟ ' : 'האם אתה בטוח שברצונך למחוק אותו?') }}
            </p>
        </div>
        <div class="modal-footer">
  
          <button type="button" 
           class="btn btn-sm m-auto mt-2" 
          style="background-color: #141414; color: #fff;"
           (click)="deleteProductById()"
           > 
            {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
            <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
        </button>
    
            <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
                {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
                <i class="fa fa-rotate-left mx-1"></i>
            </button>
    
          
    
        </div>
    </ng-template>






    <!--products info -->

<ng-container *ngIf="isInsideModal">

  <div class="container-fluid basic_table" >
      <div class="row">
  <div class="col-sm-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <h5 style="color: grey;"> 
              {{ curentLang === 'en' ? 'Products Info' : (curentLang === 'ar' ? '  معلومات المنتجات ' : ' מידע על מוצרים ')}}
          </h5>
  
         <div>
          <button [hidden]="user_type == 200 || user_type == 201" class="btn m-1" style=" background-color: #141414; color: #fff;" (click)="openXl(content)">
              <i class="fa fa-plus-circle mx-1"></i>
            {{ curentLang === 'en' ? 'Add Product' : (curentLang === 'ar' ? '  اضافة منتج' : ' הוספת מוצר   ')}}
          </button>

          <button [hidden]="user_type == 200 || user_type == 201" class="btn m-1 btn-outline-success" (click)="downloadTemplate()">
            <i class="fa fa-download mx-1"></i>
            {{ curentLang === 'en' ? 'Download Template' : (curentLang === 'ar' ? 'تنزيل القالب' : 'הורד תבנית') }}
          </button>

          <label [hidden]="user_type == 200 || user_type == 201" class="btn m-1 btn-outline-primary mb-0" style="cursor:pointer;">
            <i class="fa fa-file-excel-o mx-1"></i>
            {{ curentLang === 'en' ? 'Import Excel' : (curentLang === 'ar' ? 'استيراد Excel' : 'ייבוא Excel') }}
            <input type="file" accept=".xlsx,.xls" style="display:none;" (change)="onExcelFileSelected($event)" />
          </label>
  
          <button class="btn m-1 mx-1 btn-outline-warning"  (click)="getAllProductsBasedOnMerchant()">
            <i class="fa fa-refresh mx-1"></i> {{ curentLang === 'en' ? 'Refresh' : (curentLang === 'ar' ? '  تحديث   ' : '  רענון    ')}}
        </button>
  
           </div>
       
        </div>
        <div class="row">
          <div class="col-sm-5">
              <div class="form-group search m-3">
                <label for="seaarch" class="ml-2" style="color: grey;"> {{curentLang === 'en' ? 'Search' : (curentLang === 'ar' ? 'بحث' : 'חיפוש')}}  </label>
                   <input class="form-control  w-100" type="text" name="search"
                    [ngModelOptions]="{standalone: true}" id="seaarch" [(ngModel)]="term"
                    (input)="onSearchInput()"
                    placeholder=" {{curentLang === 'en' ? 'Search name / SKU / barcode' : (curentLang === 'ar' ? 'بحث بالاسم / SKU / الباركود' : 'חיפוש שם / SKU / ברקוד')}}"/>
              </div>
          </div>
      </div>


       
      

      <div class="row">
        <div class="col-sm-12">
           
            <div class="card"  id="headingTwo"
             *ngFor="let item of productsData  | paginate: {itemsPerPage:50, currentPage:p }; let i = index ">
            
                    <p   
                    
                    (click)="toggleCollapse(i)" 
                    [attr.aria-expanded]="openedIndex === i" 
                    aria-controls="collapse"
                    style="cursor: pointer; background-color: #FB4438;" 
                    class="py-1">
                      <i class="fa fa-user-circle mx-1"  style="color: #fff; font-size: 16px;" > </i>
                      <span style="color: #fff; font-size: 16px;" class="mx-2">
                        {{curentLang === 'en' ? item.product_name_en?.slice(0, 20) : (curentLang === 'ar' ? item.product_name_ar?.slice(0, 20) : item.product_name_he?.slice(0, 20))}}

                      </span>
                    </p>
              
                     
                    <div class="row d-flex justify-content-between">
        
                      <div class="col-md-12  col-sm-12 ">
                        <div class="row collapse   show" id="collapseTwo" [ngbCollapse]="openedIndex !== i">
        
                       
                        <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                          <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                            {{ curentLang === 'en' ? 'Product Name' : (curentLang === 'ar' ? ' اسم المنتج ' : ' שם המוצר  ')}}
                          </span>
                            <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                              {{curentLang === 'en' ? item.product_name_en?.slice(0, 20) : (curentLang === 'ar' ? item.product_name_ar?.slice(0, 20) : item.product_name_he?.slice(0, 20))}}
                            </span>
                            <span class="col-sm-4   text-end ">
                              <i class="fa fa-info-circle px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                            </span>
                         </div>
                         <hr style="border: solid 1px #141414;" >
                         <!---->
              
                         <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                          <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                            {{ curentLang === 'en' ? 'Product Description ' : (curentLang === 'ar' ? '   وصف المنتج  ' : '    תיאור מוצר  ')}}
                          </span>
                            <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                              {{curentLang === 'en' ? item.des_en?.slice(0, 20) : (curentLang === 'ar' ? item.des_ar?.slice(0, 20) : item.des_he?.slice(0, 20))}}
                            </span>
                            <span class="col-sm-4   text-end ">
                              <i class="fa fa-info-circle px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                            </span>
                         </div>
                         <hr style="border: solid 1px #141414;" >
        
                         <!---->
                         <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                          <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                            {{ curentLang === 'en' ? 'Product Code' : (curentLang === 'ar' ? '   رقم الصنف  ' : '  קוד מוצר  ')}}
                          </span>
                            <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                              {{item.product_code}}
                            </span>
                            <span class="col-sm-4   text-end ">
                              <i class="fa fa-info-circle px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                            </span>
                         </div>
                         <hr style="border: solid 1px #141414;" >
        
                           <!---->
        
                           <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                            <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                              {{ curentLang === 'en' ? 'Product Price' : (curentLang === 'ar' ? '   سعر المنتج  ' : '    מחיר מוצר  ')}}
                            </span>
                              <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                                {{item.price}}
                              </span>
                              <span class="col-sm-4   text-end ">
                                <i class="fa fa-money px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                              </span>
                           </div>
                           <hr style="border: solid 1px #141414;" >
                              
                         
                            <!---->
                        
                            <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                              <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                                {{ curentLang === 'en' ? 'Product Category' : (curentLang === 'ar' ? '   قسم المنتج  ' : ' קטגוריה')}}
                              </span>
                                <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                                  {{curentLang === 'en' ? item.categories?.categories_name_en : (curentLang === 'ar' ? item.categories?.categories_name_ar : item.categories?.categories_name_he)}}
                                </span>
                                <span class="col-sm-4   text-end ">
                                  <i class="fa fa-info-circle px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                                </span>
                             </div>
                             <hr style="border: solid 1px #141414;" >
                                
                   
                           
                              <!---->
                
                              <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                                <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                                  {{ curentLang === 'en' ? 'Product Measurement Unit' : (curentLang === 'ar' ? '   وحدة قياس المنتج  ' : 'יחידת מדידה')}}
                                </span>
                                  <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                                    {{curentLang === 'en' ? item.measurementUnits?.measurement_unit_name_en : (curentLang === 'ar' ? item.measurementUnits?.measurement_unit_name_ar : item.measurementUnits?.measurement_unit_name_he)}}                                  </span>
                                  <span class="col-sm-4   text-end ">
                                    <i class="fa fa-info-circle px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                                  </span>
                               </div>
                               <hr style="border: solid 1px #141414;" >


                                <!---->
        
                               <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">

                                <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2 " >
                                  {{ curentLang === 'en' ? 'Status  ' : (curentLang === 'ar' ? ' الحالة ' : 'סטטוס ')}}
                                </span>
                                
                                <div class="text-center col-sm-4  ">  
                                  
                                </div>
                                  <span style="color: #141414;   " class="text-end col-sm-4"   >
                                    
                                    <span class="col-sm-4   text-end  ">
                                      <button [disabled]="item.user_type === 200 || item.user_type === 100"  
                                      class="btn px-5"
                                       style="border: none;" 
                                       *ngIf="item.product_status==1"  style="border: none;" (click)="changeStatus(item?.product_id, item.product_status)">
                                        <i class="fa solid fa-solid fa-toggle-on " style=" color: #213FA6; "></i>
                                      </button> 
                                      
                                      <button *ngIf="item.product_status==59" class=" btn px-5"  style="border: none;"(click)="changeStatus(item?.product_id, item.product_status)">
                                        <i class="fa solid fa-solid fa-toggle-off " style=" color: red;"></i>
                                      </button> 
                                    </span>
                                      
                                    
                                </span>
              
                             
                               </div>
                               <hr style="border: solid 1px #141414;" > 

                                     <!---->
                        
                            <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                              <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                                {{ curentLang === 'en' ? 'Created Date' : (curentLang === 'ar' ? '  تاريخ التسجيل' : 'תאריך הרשמה')}}
                              </span>
                                <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                                  {{ item.createdDate | date: 'dd/MM/yyyy'}}
                                </span>
                                <span class="col-sm-4   text-end ">
                                  <i class="fa fa-history px-5 "  style="color: #141414; font-size: 16px ;" ></i>
                                </span>
                             </div>
                             <hr style="border: solid 1px #141414;" >


                                        <!---->
                        
                            <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                              <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                                {{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? '   عرض' : '  הצגה   ')}}
                              </span>
                                <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                                   
                                </span>
                                <span class="col-sm-4   text-end ">
                                  <button class=" btn px-5" style="border: none;" (click)="executeFunctionsView(  item?.product_id,viewData ) ">
                                    <i class="fa fa-eye" style="color: grey;   cursor: pointer;"></i>
                                </button>
                                </span>
                             </div>
                             <hr style="border: solid 1px #141414;" >


              <!---->
                        
              <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
                <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
                  {{ curentLang === 'en' ? 'Update  ' : (curentLang === 'ar' ? '   تعديل  ' : '  עריכה ')}}
                </span>
                  <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
                     
                  </span>
                  <span class="col-sm-4   text-end ">
                    <button class=" btn px-5" style="border: none;"
                    (click)="executeFunctions(  item?.product_id,updatedData ) ">
                     <i class="fa fa-edit" style=" cursor: pointer; color: green;">
                    </i>
                   </button>
                  </span>
               </div>
               <hr style="border: solid 1px #141414;" >

   <!---->
                        
   <div class="col-md-12 col-sm-12 col-xs-12  d-flex justify-content-between  ">
    <span style="color: #141414; font-size: 14px;  ;" class="col-sm-4 mx-2" >
      {{ curentLang === 'en' ? 'Delete  ' : (curentLang === 'ar' ? '   حذف  ' : 'מחיקה')}}

    </span>
      <span style="color: #141414; font-size: 14px; " class="text-center col-sm-4" >
         
      </span>
      <span class="col-sm-4   text-end ">
        <button 
        [ngStyle]="{ 'pointer-events': item.product_status == 1 ? 'none' : 'auto', 'color': item.product_status == 1 ? 'gray' : 'red' }" 
        class="btn px-5" 
        style="border: none;" 
        (click)="getId(item?.product_id);openVerticallyCentered(dataDeleted)">
          <i class="fa fa-trash-o" style=" cursor: pointer;"></i>
          </button>
      </span>
   </div>
   <hr style="border: solid 1px #141414;" >





                        </div>
                      </div>
        
                    </div>
                    <hr style="color: #141414; border: solid 1px;">
            </div>
        
            <pagination-controls (pageChange)="p = $event" class="m-auto my-3 current" > </pagination-controls>    
        
        
        
        
          </div>
        
            </div>





      </div>
    </div>
  
      </div>
  </div>
  
  </ng-container>

<!-- Import Result Modal -->
<ng-template #importResultModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color: grey;">
      {{ curentLang === 'en' ? 'Import Summary' : (curentLang === 'ar' ? 'ملخص الاستيراد' : 'סיכום ייבוא') }}
    </h6>
    <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" *ngIf="importResult">

    <!-- counters -->
    <div class="d-flex gap-3 mb-4 flex-wrap">
      <div class="text-center px-4 py-3 rounded" style="background:#e8f5e9; flex:1; min-width:100px;">
        <div style="font-size:1.6rem; font-weight:700; color:#2e7d32;">{{ importResult.created?.length ?? 0 }}</div>
        <div style="color:#2e7d32; font-size:.85rem;">
          {{ curentLang === 'en' ? 'Created' : (curentLang === 'ar' ? 'تم إنشاؤها' : 'נוצרו') }}
        </div>
      </div>
      <div class="text-center px-4 py-3 rounded" style="background:#fff8e1; flex:1; min-width:100px;">
        <div style="font-size:1.6rem; font-weight:700; color:#f57f17;">{{ importResult.skipped?.length ?? 0 }}</div>
        <div style="color:#f57f17; font-size:.85rem;">
          {{ curentLang === 'en' ? 'Skipped' : (curentLang === 'ar' ? 'تم تخطيها' : 'דולגו') }}
        </div>
      </div>
      <div class="text-center px-4 py-3 rounded" style="background:#fce4ec; flex:1; min-width:100px;">
        <div style="font-size:1.6rem; font-weight:700; color:#c62828;">{{ importResult.errors?.length ?? 0 }}</div>
        <div style="color:#c62828; font-size:.85rem;">
          {{ curentLang === 'en' ? 'Errors' : (curentLang === 'ar' ? 'أخطاء' : 'שגיאות') }}
        </div>
      </div>
    </div>

    <!-- created -->
    <div *ngIf="importResult.created?.length > 0" class="mb-3">
      <h6 style="color:#2e7d32;">
        <i class="fa fa-check-circle mx-1"></i>
        {{ curentLang === 'en' ? 'Created Products' : (curentLang === 'ar' ? 'المنتجات التي تم إنشاؤها' : 'מוצרים שנוצרו') }}
      </h6>
      <div class="table-responsive">
        <table class="table table-sm table-hover text-center">
          <thead class="table-success">
            <tr>
              <th>{{ curentLang === 'en' ? 'Row' : (curentLang === 'ar' ? 'صف' : 'שורה') }}</th>
              <th>{{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}</th>
              <th>ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of importResult.created">
              <td>{{ item.row }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.product_id }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- skipped -->
    <div *ngIf="importResult.skipped?.length > 0" class="mb-3">
      <h6 style="color:#f57f17;">
        <i class="fa fa-exclamation-circle mx-1"></i>
        {{ curentLang === 'en' ? 'Skipped Rows' : (curentLang === 'ar' ? 'الصفوف التي تم تخطيها' : 'שורות שדולגו') }}
      </h6>
      <div class="table-responsive">
        <table class="table table-sm table-hover text-center">
          <thead class="table-warning">
            <tr>
              <th>{{ curentLang === 'en' ? 'Row' : (curentLang === 'ar' ? 'صف' : 'שורה') }}</th>
              <th>{{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}</th>
              <th>{{ curentLang === 'en' ? 'Code' : (curentLang === 'ar' ? 'الكود' : 'קוד') }}</th>
              <th>{{ curentLang === 'en' ? 'Reason' : (curentLang === 'ar' ? 'السبب' : 'סיבה') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of importResult.skipped">
              <td>{{ item.row }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.product_code }}</td>
              <td>{{ item.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- errors -->
    <div *ngIf="importResult.errors?.length > 0">
      <h6 style="color:#c62828;">
        <i class="fa fa-times-circle mx-1"></i>
        {{ curentLang === 'en' ? 'Errors' : (curentLang === 'ar' ? 'الأخطاء' : 'שגיאות') }}
      </h6>
      <div class="table-responsive">
        <table class="table table-sm table-hover text-center">
          <thead class="table-danger">
            <tr>
              <th>{{ curentLang === 'en' ? 'Row' : (curentLang === 'ar' ? 'صف' : 'שורה') }}</th>
              <th>{{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}</th>
              <th>{{ curentLang === 'en' ? 'Reason' : (curentLang === 'ar' ? 'السبب' : 'סיבה') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of importResult.errors">
              <td>{{ item.row }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-secondary" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Close' : (curentLang === 'ar' ? 'إغلاق' : 'סגור') }}
    </button>
  </div>
</ng-template>

<!-- AI Image Preview Modal -->
<ng-template #aiPreviewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color: grey;">
      {{ curentLang === 'en' ? 'AI Image Preview' : (curentLang === 'ar' ? 'معاينة صورة AI' : 'תצוגה מקדימה של תמונת AI') }}
    </h6>
    <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="aiPreviewUrl" [src]="aiPreviewUrl" alt="AI preview" class="product-ai-preview" />
    <p class="text-muted mt-2 mb-0">
      {{ curentLang === 'en' ? 'Approve to save this image on the product.' : (curentLang === 'ar' ? 'اعتمد لحفظ هذه الصورة على المنتج.' : 'אשר כדי לשמור את התמונה על המוצר.') }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" style="background-color:#141414;color:#fff;" (click)="approveAiImage(modal)">
      {{ curentLang === 'en' ? 'Approve' : (curentLang === 'ar' ? 'اعتماد' : 'אישור') }}
      <i class="fa fa-check-circle mx-1"></i>
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
  </div>
</ng-template>